module.exports = __webpack_public_path__ + "img/cases-brand-2-cover.fce6861c.png";